var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.333.342c-.833.408-1.65.574-2.5.825C13.9.113 12.514.054 11.183.553 9.853 1.05 8.981 2.269 9 3.667V4.5c-2.704.07-5.113-1.162-6.667-3.333 0 0-3.485 6.194 3.334 9.166-1.56 1.04-3.116 1.74-5 1.667 2.756 1.502 5.76 2.02 8.361 1.264 2.983-.866 5.435-3.102 6.376-6.451.28-1.02.42-2.071.414-3.128-.002-.207 1.258-2.31 1.515-3.344"
  })));
};
export default SvgTwitter;